import { PlanName, PlanNameEnum, PricingTableKey } from 'base/accounts_service';
import { UnreachableError } from 'base/helpers';

export function getHumanPlanName(planName: PlanNameEnum) {
  switch (planName) {
    case PlanName.FREE:
      return 'Free';
    case PlanName.STARTER:
      return 'Starter';
    case PlanName.PRO:
      return 'Pro';
    case PlanName.TEAM:
      return 'Team';
    default:
      throw new UnreachableError(planName);
  }
}

export function getPlanName(planKey: PricingTableKey) {
  switch (planKey) {
    case 'free':
      return PlanName.FREE;
    case 'starterMonthly':
    case 'starterYearly':
      return PlanName.STARTER;
    case 'proYearly':
    case 'proMonthly':
      return PlanName.PRO;
    case 'teamMonthly':
    case 'teamYearly':
      return PlanName.TEAM;
    default:
      throw new UnreachableError(planKey);
  }
}

export function getBillingInterval(planKey?: PricingTableKey) {
  switch (planKey) {
    case undefined:
    case 'free':
      return 'forever';
    case 'starterMonthly':
    case 'proMonthly':
    case 'teamMonthly':
      return 'monthly';
    case 'starterYearly':
    case 'proYearly':
    case 'teamYearly':
      return 'yearly';
    default:
      throw new UnreachableError(planKey);
  }
}
